import { render, staticRenderFns } from "./Jelovnik.vue?vue&type=template&id=313ed353"
import script from "./Jelovnik.vue?vue&type=script&lang=js"
export * from "./Jelovnik.vue?vue&type=script&lang=js"
import style0 from "./Jelovnik.vue?vue&type=style&index=0&id=313ed353&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports